export const RECURSO_STATUS = {
  CRIADO: 'CRIADO',
  DEFERIDO: 'DEFERIDO',
  INDEFERIDO: 'INDEFERIDO',
  ADMISSIVEL: 'ADMISSIVEL',
  INADMISSIVEL: 'INADMISSIVEL',
};

export const DESFECHO_CONSIDERACAO = {
  DEFERIDO: 'DEFERIDO',
  INDEFERIDO: 'INDEFERIDO',
};

export const OPCOES_DESFECHO_CONSIDERACAO = [
  { id: DESFECHO_CONSIDERACAO.DEFERIDO, nome: 'Deferido' },
  { id: DESFECHO_CONSIDERACAO.INDEFERIDO, nome: 'Indeferido' },
];

export const normalizarStatusRecurso = status => {
  const chave = String(status || '').toUpperCase();

  if (chave === 'PROCEDE') return RECURSO_STATUS.DEFERIDO;
  if (chave === 'NAO_PROCEDE') return RECURSO_STATUS.INDEFERIDO;

  return chave;
};

export const RECURSO_STATUS_TERMINAIS = [
  RECURSO_STATUS.DEFERIDO,
  RECURSO_STATUS.ADMISSIVEL,
  RECURSO_STATUS.INADMISSIVEL,
];

export const isRecursoStatusTerminal = status =>
  RECURSO_STATUS_TERMINAIS.includes(normalizarStatusRecurso(status));

export const normalizarDesfechoConsideracao = desfecho => {
  const chave = String(desfecho || '').toUpperCase();

  if (chave === 'DEFERIDO' || chave === 'PROCEDE') return DESFECHO_CONSIDERACAO.DEFERIDO;
  if (chave === 'INDEFERIDO' || chave === 'NAO_PROCEDE') {
    return DESFECHO_CONSIDERACAO.INDEFERIDO;
  }

  return chave;
};
